import { CancelReasonCategory, DEFAULT_CLINIC_CANCEL_REASON_ID, DEFAULT_PATIENT_CANCEL_REASON_ID, OTHER_CANCEL_REASON_NAME, } from "./fields";
export const CancelReason = {
    CancelReasonCategory,
    OTHER_CANCEL_REASON_NAME,
    DEFAULT_PATIENT_CANCEL_REASON_ID,
    DEFAULT_CLINIC_CANCEL_REASON_ID,
};
